import { VitalsConstants } from '../store/vitals.constants'

export const vitalsSchemas = [
  // {
  //   inputKey: VitalsConstants.SET_TEMPERATURE,
  //   isNumber: true,
  //   type: 'object',
  //   properties: {
  //     SET_TEMPERATURE_F: {
  //       type: 'number',
  //       minimum: 80.0,
  //       maximum: 120.0,
  //     },
  //     SET_TEMPERATURE_C: {
  //       type: 'number',
  //       minimum: 30.0,
  //       maximum: 50.0,
  //     },
  //   },
  //   additionalProperties: false,
  // },
  {
    inputKey: VitalsConstants.SET_HEART_RATE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_HEART_RATE: {
        type: 'number',
        minimum: 0,
        maximum: 500,
      },
    },
    additionalProperties: false,
    required: ['SET_HEART_RATE'],
  },

  {
    inputKey: VitalsConstants.SET_SPCO,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SPCO: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
    },
    additionalProperties: false,
    required: ['SET_SPCO'],
  },

  {
    inputKey: VitalsConstants.SET_MAP_VITAL,
    isNumber: true,
    type: 'object',
    properties: {
      SET_MAP_VITAL: {
        type: 'number',
        minimum: 0,
        maximum: 500,
      },
    },
    additionalProperties: false,
    required: ['SET_MAP_VITAL'],
  },

  {
    inputKey: VitalsConstants.SET_RESPIRATION_RATE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_RESPIRATION_RATE: {
        type: 'number',
        minimum: 0,
        maximum: 300,
      },
    },
    additionalProperties: false,
    required: ['SET_RESPIRATION_RATE'],
  },

  {
    inputKey: VitalsConstants.SET_SPO2,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SPO2: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
    },
    additionalProperties: false,
    required: ['SET_SPO2'],
  },

  {
    inputKey: VitalsConstants.SET_SPMET,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SPMET: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
    },
    additionalProperties: false,
    required: ['SET_SPMET'],
  },

  {
    inputKey: VitalsConstants.SET_ETCO2,
    isNumber: true,
    type: 'object',
    properties: {
      SET_ETCO2: {
        type: 'number',
        minimum: 0,
        maximum: 760,
      },
    },
    additionalProperties: false,
    required: ['SET_ETCO2'],
  },

  {
    inputKey: VitalsConstants.SET_GLUCOSE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_GLUCOSE: {
        type: 'integer',
        minimum: 0,
        maximum: 2000,
      },
    },
    additionalProperties: false,
    required: ['SET_GLUCOSE'],
  },

  {
    inputKey: VitalsConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },

  {
    inputKey: VitalsConstants.SET_SYSTOLIC_BLOOD_PRESSURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SYSTOLIC_BLOOD_PRESSURE: {
        type: 'integer',
        minimum: 0,
        maximum: 500,
      },
    },
    additionalProperties: false,
    required: ['SET_SYSTOLIC_BLOOD_PRESSURE'],
  },

  {
    inputKey: VitalsConstants.SET_DIASTOLIC_BLOOD_PRESSURE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DIASTOLIC_BLOOD_PRESSURE: {
        type: 'string',
        pattern: '^([5][0][0]|[1-4][0-9][0-9]|[0-9]|[1-9][0-9]|P|p)$',
      },
    },
    additionalProperties: false,
    required: ['SET_DIASTOLIC_BLOOD_PRESSURE'],
    errorMessage: {
      properties: {
        SET_DIASTOLIC_BLOOD_PRESSURE: 'Must be 0-500 or P',
      },
    },
  },

  // {
  //   inputKey: VitalsConstants.SET_COMMENTS,
  //   isNumber: false,
  //   type: 'object',
  //   properties: {
  //     SET_COMMENTS: {
  //       type: 'string',
  //       pattern: '^([\x20-\x7F]){1,1000}$',
  //     },
  //   },
  //   additionalProperties: false,
  //   required: ['SET_COMMENTS'],
  //   errorMessage: {
  //     properties: {
  //       SET_COMMENTS: 'Must be alphanumeric with max length of 1000',
  //     },
  //   },
  // },

  {
    inputKey: VitalsConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
]

export const vitalSchemaSeconds = [
  {
    inputKey: VitalsConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
